/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_No_Receipt_NoteInputs */

const vi_confirm_return_no_receipt_note = /** @type {(inputs: Confirm_Return_No_Receipt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(sẽ không tạo phiếu nhập vật tư)`)
};

/**

* @param {Confirm_Return_No_Receipt_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_no_receipt_note = /** @type {((inputs?: Confirm_Return_No_Receipt_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_No_Receipt_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_no_receipt_note(inputs)
});